import { useNavigate } from 'react-router-dom';
import { deleteCookie } from '../../Utils/CookieUtils';
import { TErrorBoundaryComponentProps } from './ErrorBoundaryComponent.type';
import { COOKIE_IDS, CUSTOM_ERROR_CODE } from '../../Constants/Constants';
import './ErrorBoundaryComponent.scss';

const ErrorBoundaryComponent = (props: TErrorBoundaryComponentProps) => {
  const { errorCode } = props;
  const navigate = useNavigate();
  const onBackBtnClicked = async () => {
    navigate(-1);
  };

  const onHomeBtnClicked = async () => {
    navigate('/', { replace: true });
  };
  const renderAccordingToErrorCode = (errorCode: string | undefined | null) => {
    switch (errorCode) {
      case CUSTOM_ERROR_CODE.Authorization_Error:
        return (
          <div className="Authorization">
            <h1>Authorization Error</h1>
            <p>Sorry, you are not authorized to use this application.</p>
            <button
              className="primary-cta-btn"
              onClick={() => {
                deleteCookie('id_token');
                deleteCookie('unique_id');
                deleteCookie('session_info');
                deleteCookie(COOKIE_IDS?.PREFERRED_TIME_FORMAT);
                localStorage.clear();
                window.location.replace('https://schneiderowneroperators.com/');
              }}
            >
              Ok
            </button>
          </div>
        );
      default:
        return (
          <div className="General">
            <h1>Something went wrong...</h1>
            <div className="Button_Container">
              <button className="primary-cta-btn" onClick={onHomeBtnClicked}>
                Go Home
              </button>
              <button className="secondary-cta-btn" onClick={onBackBtnClicked}>
                Go Back
              </button>
            </div>
          </div>
        );
    }
  };
  return <div className="ErrorBoundaryComponent">{renderAccordingToErrorCode(errorCode)}</div>;
};

export default ErrorBoundaryComponent;
